import { useSignal } from "@preact/signals-react"
import { useEffect } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { reportListData } from "Pages/Main/Home/@signals"


export default function useReportsHomeInfo() {
	const { showToast } = useToast()

	const isLoading = useSignal(false)

	useEffect(() => {
		isLoading.value = true

		getSubmit(`${BACKEND_APIS.REPORTS}/list`)
			.then(r => reportListData.value = r)
			.catch(() => showToast.error())
			.finally(() => isLoading.value = false)

	}, [])


	return {
		data: reportListData.value,
		isLoading: isLoading.value
	}
}